export default __webpack_public_path__ + "static/media/36I-102791_-15926_0.2e4bf91b.jpg";